module.exports = __webpack_public_path__ + "img/3ebfab7.jpg";